/**
 * 网络请求配置
 */
import axios from 'axios'; // 引入axios
import {message} from 'antd'
import './spin.css'


/*// 显示加载动画
function showLoading () {
    let dom = document.createElement('div');
    dom.setAttribute('id', 'loading');
    document.body.appendChild(dom);
    ReactDOM.render( <Spin size="large" >
        <div className='loading_box' />
    </Spin>, dom)
}
// 隐藏加载动画
function hideLoading () {
    document.body.removeChild(document.getElementById('loading'))
}*/

/**
 * http request 拦截器
 */
axios.interceptors.request.use(
    (config) => {
        //console.log(config)
        let gToken=localStorage.getItem('token');
      /*  config.data = JSON.stringify(config.data);*/
        config.headers = {
            "Content-Type": "application/json",
            'Authorization': gToken?'JWT '+ gToken.split("&&")[0]:''//用户身份验证信息
        };
        if(config.url.match('/v1/token-auth/')||config.url.match('/v1/channel/')||config.url.match('/v1/system_settings/')||config.url.match('/v1/friend_link/')||config.url.match('/v1/wechat-official-login/')||config.url.match('/v1/wechat-scan-login/')||config.url.match('/v3/config/')){
            config.headers = {
                "Content-Type": "application/json",
                //'Authorization': gToken?'JWT '+ gToken.split("&&")[0]:''//用户身份验证信息
            };
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
/**
 * http response 拦截器
 */
axios.interceptors.response.use(
    (response) => {
        if(response.status < 300){
            return response.data;
        }
    },
    (error) => {
        if(error&& (error.response.config.url.match('register')
                || error.response.config.url.match('forum/topic') //帖子
                || (error.response.config.url.match('news')&&error.response.config.url.match(/[1-9]\d/))  //治疗方案，文章类详情
            )
        ){///注册接口
            return error.response;
        }
        msag(error)
    }
);
let outFF = {
    /**
     * 封装get方法
     * @param url  请求url
     * @param params  请求参数
     * @returns {Promise}
     */
    get(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params,
            }).then((response) => {
                resolve(response);
            })
                .catch((error) => {
                    msag(error);
                    reject(error);
                });
        });
    },

    /**
     * 封装post请求
     * @param url
     * @param data
     * @returns {Promise}
     */

    post(url, data ,config) {
        return new Promise((resolve, reject) => {
            axios.post(url, data ,config).then(
                (response) => {
                    //关闭进度条
                    resolve(response);
                },
                (err) => {
                    msag(err);
                    reject(err);
                }
            );
        });
    },

    /**
     * 封装patch请求
     * @param url
     * @param data
     * @returns {Promise}
     */
    patch(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.patch(url, data).then(
                (response) => {
                    resolve(response);
                },
                (err) => {
                    msag(err);
                    reject(err);
                }
            );
        });
    },

    /**
     * 封装put请求
     * @param url
     * @param data
     * @returns {Promise}
     */

    put(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.put(url, data).then(
                (response) => {
                    resolve(response);
                },
                (err) => {
                    msag(err);
                    reject(err);
                }
            );
        });
    }
};

export default outFF
//失败提示
function msag(err) {
   // hideLoading ()
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                for (let key in  err.response.data) {
                    if(typeof err.response.data[key]==="string"){
                        message.error(err.response.data[key]);
                    }else {
                        if(Object.prototype.toString.call(err.response.data[key])==='[object Array]'){
                            if(key==='email'){
                                err.response.data[key].map((item,index)=>{
                                    message.error('邮箱已被注册，'+item.toString());
                                    return item
                                })
                            }else {
                                err.response.data[key].map((item,index)=>{
                                    message.error(item.toString());
                                    return item
                                })
                            }
                        }else if(Object.prototype.toString.call(err.response.data[key])==='[object Object]'){
                            for (let key2 in  err.response.data[key]) {
                                err.response.data[key][key2].map((item,index)=>{
                                    message.error(item.toString());
                                    return item
                                })
                            }
                        }
                    }
                }
                break;
            case 401:
                message.error("未授权，请登录");
                window.location.hash='#/login';
                break;

            case 403:
                for (let key in  err.response.data) {
                    message.error(err.response.data[key]);
                }
                break;

            case 404:
                for (let key in  err.response.data) {
                    message.error(err.response.data[key]);
                }
                break;

            case 408:
                message.error("请求超时");
                break;
            case 429:
                message.error("请求超过了限速。请耐心等待1分钟");
                break;
            case 500:
                message.error("服务器内部错误");
                break;

            case 501:
                message.error("服务未实现");
                break;

            case 502:
                message.error("网关错误");
                break;

            case 503:
                message.error("服务不可用");
                break;

            case 504:
                message.error("网关超时");
                break;

            case 505:
                message.error("HTTP版本不受支持");
                break;
            default:
        }
    }
}
